<script>
import ChatMessage from '@components/chat-message'
import Card from '@components/card-div'
import { RELOAD, WEBSOCKET } from '@constants/Text'
import { workspace } from '@constants/URL'
import { GlobalBus } from '@services/bus'
import { getUnique } from '@utils/Format'
import store from '@state/store'
import con from '@connection'

export default {
  components: { ChatMessage, Card },
  data() {
    return {
      room: {},
      messages: [],
      step_chat: '1',
      text_message: '',
      show_chat: false,
      showMenu: false,
      index_room: null,
      menu_chat: false,
      filterRooms: '',
      pagination: 0,
      loadingMessages: false,
    }
  },
  computed: {
    IS_WHITELABEL() {
      return this.$showWorkspace
    },
    online() {
      return store.getters['websocket/workspaceConnected']
    },
    canShow() {
      return this.IS_WHITELABEL && store.getters['parameters/show'].workspace
    },
    rooms() {
      return this.$store.getters['chat/rooms']
    },
    roomsColective() {
      return store.getters['chat/roomsColective'].filter((r) => {
        return r.nome.toLowerCase().includes(this.filterRooms.toLowerCase())
      })
    },
    roomsIndividuals() {
      return store.getters['chat/roomsIndividuals'].filter((s) => {
        return s.nome.toLowerCase().includes(this.filterRooms.toLowerCase())
      })
    },
    faviconEscritorio() {
      return store.getters['parameters/favicon']
    },
  },
  watch: {
    menu_chat() {
      setTimeout(() => {
        this.step_chat = '1'
        this.index_room = null
      }, 300)
    },
    rooms(newValue) {
      if (this.room && this.room.token_sala) {
        this.room = this.rooms.find((r) => {
          return r.token_sala === this.room.token_sala
        })
      }
    },
    room(newValue, oldValue) {
      store.dispatch('chat/unselectRoom', oldValue.token_sala)
      store.dispatch('chat/selectRoom', newValue.token_sala)

      if (this.$refs.campoMensagem) {
        this.$refs.campoMensagem.focus()
      }

      if (newValue && oldValue && newValue.token_sala !== oldValue.token_sala) {
        this.messages = []
        this.pagination = 0
      }

      this.loadMessages(
        newValue && oldValue && newValue.token_sala !== oldValue.token_sala
      )
    },
  },
  mounted() {
    if (!this.$currentUser().IS_CLIENTE) {
      this.$store.dispatch('chat/loadRooms')

      setTimeout(() => {
        this.show_chat = true
      }, 1000)

      // Handlers nomeados: $off/removeEventListener exigem a MESMA referência
      // registrada — arrows inline aqui vazavam no GlobalBus (singleton vitalício)
      globalThis.addEventListener('click', this.closeChatMenu)

      GlobalBus.$on(WEBSOCKET.WORKSPACE_MESSAGE, this.addMessage)
      GlobalBus.$on(RELOAD.ROOMS, this.loadRooms)
      GlobalBus.$on(WEBSOCKET.WORKSPACE_RELOAD_MSG, this.reloadChatMessages)
    }
  },
  beforeDestroy() {
    globalThis.removeEventListener('click', this.closeChatMenu)
    GlobalBus.$off(WEBSOCKET.WORKSPACE_MESSAGE, this.addMessage)
    GlobalBus.$off(RELOAD.ROOMS, this.loadRooms)
    GlobalBus.$off(WEBSOCKET.WORKSPACE_RELOAD_MSG, this.reloadChatMessages)
  },
  methods: {
    closeChatMenu() {
      this.menu_chat = false
    },
    reloadChatMessages() {
      this.loadMessages(false)
    },
    pushNotification(msg) {
      // TODO: Alguma forma de remover o som?
      try {
        if ('Audio' in window) {
          const audio = new Audio(
            'https://aawz-public.s3.us-east-2.amazonaws.com/sounds/notification.wav'
          )
          audio.play()
        }
      } catch (e) {
        console.warn('erro audio', e)
      }

      if (Notification.permission !== 'granted') {
        return
      }
      const room =
        this.rooms.find((r) => {
          return r.token_sala === msg.token_sala
        }) || {}

      const opt = {
        body: `${msg.sender_name.split(' ')[0]}: ${msg.mensagem}`,
        badge: this.faviconEscritorio,
      }
      if (msg.trigger_action) {
        opt['actions'] = [
          {
            action: msg.trigger_action,
            title: msg.trigger_action,
          },
        ]
      }
      const title = room.nome || 'Nova mensagem no workspace'
      navigator.serviceWorker
        .getRegistration(process.env.BASE_URL)
        .then((r) => {
          r.showNotification(title, opt)
        })
    },
    loadRooms(opts) {
      if (opts && typeof opts !== 'undefined') {
        store.dispatch('chat/loadRooms', opts.show_loading)
      } else {
        store.dispatch('chat/loadRooms')
      }
    },
    async loadMessages(signal = true) {
      if (!this.room.token_sala) {
        return
      }

      if (signal) {
        this.loadingMessages = true
      }

      const r = await con.get(
        workspace.room_messages + `${this.room.token_sala}?pagination_number=0`
      )
      if (r.status === 200) {
        this.messages = r.value
      } else {
        this.messages = []
      }
      if (signal) {
        this.loadingMessages = false
      }
    },
    sendMessage() {
      if (!this.text_message) {
        return
      }
      const msg = {
        mensagem: this.text_message,
        token_sala: this.room.token_sala,
        evento_tipo: 'message',
        mensagem_tipo: 'message',
        owner: true,
        trigger_action: null,
        body: null,
        message_token: this.genMessageToken(),
      }
      this.addMessage(msg)
      this.$wsWorkspace.sendMessage(msg)
      this.text_message = ''
    },
    genMessageToken() {
      return `${new Date().getTime()}::${this.room.token_sala}`
    },
    addMessage(m) {
      console.log('Recebendo msg (chat-popup:addMessage)', m)
      if (this.room && this.room.token_sala === m.token_sala) {
        if (this.messages) {
          const old = this.messages.find((msg) => {
            return msg.message_token === m.message_token
          })
          if (old) {
            Object.assign(old, m)
          } else {
            this.messages.push(m)
          }
        } else {
          this.messages = [m]
        }
        if (!m.owner) {
          this.readRoom(m.token_sala)
        }
      } else {
        store.dispatch('chat/incrementQtdUnread', m.token_sala)
        if (!m.owner) {
          this.pushNotification(m)
        }
      }
    },
    async loadMore() {
      console.log('load more')
      if (this.loadingMessages) {
        return
      }

      if (this.messages.length < this.pagination * 100 + 100) {
        return
      }
      this.loadingMessages = true

      const element = document.getElementById('historicoMensagensPopup')
      const h = element.scrollHeight

      const r = await con.get(
        workspace.room_messages +
          `${this.room.token_sala}?pagination_number=${this.pagination + 1}`
      )

      if (r.status === 200) {
        this.pagination += 1

        this.messages = getUnique([...r.value, ...this.messages], 'id')

        this.$nextTick(() => {
          element.scrollTop = element.scrollHeight - h
        })
      }

      this.loadingMessages = false
    },
    showDetailsRoom() {
      this.$showModal({
        title: this.room.nome,
        text: this.room.descricao,
      })
    },
    clearRoomSelection() {
      this.step_chat = '1'
      this.index_room = null
      store.dispatch('chat/unselectRoom', this.room.token_sala)
      this.room = {}
    },
    readRoom(token) {
      store.dispatch('chat/readRoom', token)
    },
  },
}
</script>

<template>
  <v-fab-transition>
    <div v-if="canShow" class="v-application" data-app @click.stop>
      <v-menu
        ref="menu-chat"
        v-model="menu_chat"
        :close-on-content-click="false"
        :nudge-width="300"
        offset-y
        offset-overflow
        rounded="lg"
      >
        <template v-slot:activator="{ on, attrs, value }">
          <v-btn
            v-show="show_chat"
            dark
            fab
            class="dont-show-print"
            v-bind="attrs"
            v-on="on"
          >
            <div v-if="!value">
              <icon-svg name="chats" />
              <div
                v-if="$store.getters['chat/allUnread']"
                class="elevation-10"
                style="position: absolute;top: -20px;right: 0;background: white;color: var(--primary);border-radius: 20px;padding: 0px 4px 3px;"
              >
                <small>{{ $store.getters['chat/allUnread'] }}</small>
              </div>
            </div>
            <div v-if="value">
              <v-icon>mdi-close</v-icon>
            </div>
          </v-btn>
        </template>
        <v-card style="min-height: 500px;">
          <v-stepper v-model="step_chat">
            <v-stepper-header
              class="elevation-10 text-white"
              style="background-color: var(--primary)"
            >
              <div v-if="step_chat === '1'">
                <v-card-title>
                  Workspace
                </v-card-title>
              </div>
              <div v-if="step_chat === '2'">
                <v-card-title style="width:368px;">
                  <div
                    class="full-center flex-row justify-content-between"
                    style="width: 100%"
                  >
                    <div class="full-center flex-row" style="max-width: 95%;">
                      <v-icon style="color: white;" @click="clearRoomSelection">
                        mdi-chevron-left
                      </v-icon>
                      <p
                        class="mb-0"
                        style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden;"
                      >
                        {{ room.nome }}
                      </p>
                    </div>
                    <div @click.stop>
                      <v-menu ref="listaMenu" v-model="showMenu" bottom left>
                        <template v-slot:activator="{ on }">
                          <v-btn icon v-on="on">
                            <v-icon color="white"> mdi-dots-vertical </v-icon>
                          </v-btn>
                        </template>

                        <v-list>
                          <!-- <v-list-item @click="">
                            <v-list-item-title>
                              Limpar conversa
                            </v-list-item-title>
                          </v-list-item> -->
                          <v-list-item @click="showDetailsRoom">
                            <v-list-item-title> Detalhes </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>
                  </div>
                </v-card-title>
              </div>
            </v-stepper-header>
            <p v-if="!online" class="m-10">
              <small class="text-bold text-danger">
                Você está offline. Estamos tentando reconectar.
              </small>
            </p>
            <v-stepper-items style="height: 444px; overflow-y: auto;">
              <v-stepper-content class="p-0" step="1">
                <div>
                  <div class="px-3 mt-3">
                    <v-text-field
                      v-model="filterRooms"
                      filled
                      append-icon="search"
                      dense
                      height="60"
                      hide-details
                      placeholder="Pesquisar canais"
                    />
                  </div>
                  <v-list>
                    <v-list-item-group v-model="index_room">
                      <v-subheader
                        v-if="roomsColective.length"
                        class="text-bold"
                      >
                        Canais Coletivos
                      </v-subheader>
                      <template v-if="roomsColective.length">
                        <v-list-item
                          v-for="s in roomsColective"
                          :key="s.nome"
                          class="v-application"
                          @click="
                            () => {
                              room = s
                              step_chat = '2'
                            }
                          "
                        >
                          <div
                            class="full-center justify-content-between"
                            style="width: 100%; flex-direction: row;"
                          >
                            <label> {{ s.nome }} </label>
                            <v-chip
                              v-if="s.unread_quantity"
                              color="primary"
                              x-small
                            >
                              {{ s.unread_quantity }}
                            </v-chip>
                          </div>
                        </v-list-item>
                      </template>
                      <v-divider
                        v-if="roomsColective.length && roomsIndividuals.length"
                      />
                      <v-subheader
                        v-if="roomsIndividuals.length"
                        class="text-bold"
                      >
                        Canais Individuais
                      </v-subheader>
                      <template v-if="roomsIndividuals.length">
                        <v-list-item
                          v-for="s in roomsIndividuals"
                          :key="s.nome"
                          @click="
                            () => {
                              room = s
                              step_chat = '2'
                            }
                          "
                        >
                          <div
                            class="full-center justify-content-between"
                            style="width: 100%; flex-direction: row;"
                          >
                            <label> {{ s.nome }} </label>
                            <v-chip
                              v-if="s.unread_quantity"
                              color="primary"
                              x-small
                            >
                              {{ s.unread_quantity }}
                            </v-chip>
                          </div>
                        </v-list-item>
                      </template>
                    </v-list-item-group>
                  </v-list>

                  <div class="full-center">
                    <p
                      v-if="!roomsColective.length && !roomsIndividuals.length"
                    >
                      Nenhum canal encontrado.
                    </p>
                  </div>
                </div>
              </v-stepper-content>

              <v-stepper-content step="2" class="p-0">
                <Card class="full-center p-0 m-0" style="height: 444px;">
                  <div
                    id="historicoMensagensPopup"
                    v-chat-scroll="{
                      always: false,
                      smooth: true,
                      scrollonremoved: false,
                      notSmoothOnInit: true,
                    }"
                    style="height: 370px; overflow-y: auto; max-width: 400px; width: 100%;"
                    @v-chat-scroll-top-reached="loadMore"
                  >
                    <div v-if="loadingMessages" class="v-application">
                      <v-progress-circular
                        indeterminate
                        color="primary"
                        style="margin:auto;"
                      />
                    </div>
                    <ChatMessage
                      v-for="m in messages"
                      :key="m.token_sala + m.data_registro"
                      :message="m"
                    />
                  </div>
                  <div
                    class="d-flex align-items-center justify-content-between"
                    style="width: 100%; padding: 5px;"
                  >
                    <v-text-field
                      ref="campoMensagem"
                      v-model="text_message"
                      autofocus
                      solo
                      rounded
                      flat
                      filled
                      hide-details
                      placeholder="Digite uma mensagem"
                      :readonly="!online"
                      @keydown.enter="sendMessage"
                    ></v-text-field>
                    <v-btn
                      fab
                      color="primary"
                      x-small
                      class="elevation-0 ml-3"
                      :disabled="!online"
                      @click="sendMessage"
                    >
                      <v-icon small>mdi-send</v-icon>
                    </v-btn>
                  </div>
                </Card>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card>
      </v-menu>
    </div>
  </v-fab-transition>
</template>
